export const COUNTDOWN_YEAR = 10;
/* MM/dd/yyyy */
export const DEFAULT_DATE = "01/07/2022";

export const FORMAT = {
  date: "dd/MM/yyyy",
  time: "kk:mm",
};
